import { subscribeToSchemeChange } from '@epic-web/client-hints/color-scheme';
import { useEffect } from 'react';
import { useRevalidator } from 'react-router';

import { getClientHintCheckScript } from '../utils/client-hints';

/**
 * @returns inline script element that checks for client hints and sets cookies
 * if they are not set then reloads the page if any cookie was set to an
 * inaccurate value.
 */
export function ClientHintCheck() {
  const { revalidate } = useRevalidator();
  useEffect(() => subscribeToSchemeChange(() => revalidate()), [revalidate]);

  return (
    <script
      // skipcq: JS-0440
      dangerouslySetInnerHTML={{
        __html: getClientHintCheckScript(),
      }}
    />
  );
}
